var _defs, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlecheDouble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15.9,
    width: 18,
    xmlSpace: "preserve",
    viewBox: "0 0 18 15.9",
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#363636;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.12119138,0.04999981)",
    id: "g854"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 3.8,12.9 5,-5 -5,-5",
    id: "path4",
    style: {
      fill: "none",
      stroke: "#363636",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 9.449989,12.9 5,-5 -5,-5",
    id: "path4-4",
    style: {
      fill: "none",
      stroke: "#363636",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDouble);
export default __webpack_public_path__ + "static/media/fleche_double.5d91fd5bda0960fae96487d6ab90dd70.svg";
export { ForwardRef as ReactComponent };